<script>
import emitter from '@/modules/events/emitter'
import { $axios } from '@/modules/http/axios'
import TaskRoutesEditor from '@/components/TasksList/TaskRoutes/TaskRoutesEditor.vue'
import ColorsEditor from '@/components/TasksList/ColorsEditor.vue'
import moment from 'moment-timezone'

export default {
  name: 'ChangeReference',
  components: { ColorsEditor, TaskRoutesEditor },
  props: ['givenTask', 'exportMonth'],
  data () {
    return {
      task: this.givenTask,
      moment: moment
    }
  },
  created () {
    this.setListeners()
  },
  methods: {
    setListeners () {
      emitter.on('taskChanged', e => {
        if (this.task.id === e.taskId) {
          $axios.get(`Task/${e.taskId}`).then((response) => {
            this.task = response.data
          })
        }
      })
    }
  }
}
</script>

<template>
  <tr
    v-for="(taskRoute, i) in task.taskRoutes.sort((a, b) => new Date(a.startDateTime) - new Date(b.startDateTime))" :key="taskRoute.id"
    :class="{ 'bg-archived': task.archived }"
    :style="{ 'background-color': taskRoute.altBackgroundColor ?? '#ffffff', 'color': taskRoute.altTextColor ?? '#000000' }"
  >
    <td v-show="!exportMonth"></td>
    <td v-show="!exportMonth"></td>
    <td>
      <div>
        {{ `${task.numer_Przejazdu}-P${i + 1}` }}
      </div>
      <ColorsEditor v-if="!exportMonth" :given-task="task" :given-task-route="taskRoute"/>
    </td>
    <td>{{ task.nazna_Firmy }}</td>
    <td>{{ taskRoute.acronyms }}</td>
    <td>{{ taskRoute.startDateTime ? moment(taskRoute.startDateTime).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }}</td>
    <td>{{ taskRoute.endDateTime ? moment(taskRoute.endDateTime).tz('Europe/Warsaw').format('DD.MM.YYYY HH:mm') : '' }}</td>
    <td v-show="!exportMonth"></td>
    <td v-show="!exportMonth"></td>
    <td>{{ taskRoute.vehicle.plateNumber }}</td>
    <td>{{ task.semitrailer ? task.semitrailer.plateNumber : 'Brak naczepy' }}</td>
    <td>{{ taskRoute.drivers.length ? taskRoute.drivers.map(d => `${d.firstName} ${d.surname}`).join(', ') : task.kierowcy.map(d => `${d.firstName} ${d.surname}`).join(', ') }}</td>
    <td>
      <div>
        {{ taskRoute.stawka.toString().replace('.', ',') }}
      </div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="stawka"/>
    </td>
    <td>
      <div>
        {{ taskRoute.waluta ?? $parent.actualCurrency }}
      </div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="waluta"/>
    </td>
    <td>
      <div v-if="taskRoute.freightForwarder">{{ taskRoute.freightForwarder }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="freightForwarder"/>
    </td>
    <td>
      <div v-if="taskRoute.fv">{{ taskRoute.fv }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="fv"/>
    </td>
    <td>
      <div v-if="taskRoute.application">{{ taskRoute.application }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="application"/>
    </td>
    <td>
      <div v-if="taskRoute.security">{{ taskRoute.security }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="security"/>
    </td>
    <td>
      <div v-if="taskRoute.extraCostCase">{{ taskRoute.extraCostCase }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="extraCostCase"/>
    </td>
    <td>
      <div v-if="taskRoute.description1">{{ taskRoute.description1 }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="description1"/>
    </td>
    <td>
      <div v-if="taskRoute.description2">{{ taskRoute.description2 }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="description2"/>
    </td>
    <td>
      <div v-if="taskRoute.description3">{{ taskRoute.description3 }}</div> <div v-else>Brak</div>
      <TaskRoutesEditor v-if="!exportMonth" :task-id="task.id" :given-task-route="taskRoute" property-key="description3"/>
    </td>
    <td v-show="!exportMonth"></td>
  </tr>
</template>

<style scoped>
.bg-archived {
  background-color: rgba(144, 144, 144, 0.28);
  cursor: not-allowed;
}
</style>
